// 齐京山
import request from '@/utils/request'

export function getDict(params) { // 获取字典
  return request({
    url: '/Dict/DictsByNameForGroup',
    method: 'get',
    params: params
  })
}
export function department(params) { // 申请科室字典
  return request({
    url: '/Depart/Departments',
    method: 'get',
    params: params
  })
}
export function checkType(params) { // 设备类型字典
  return request({
    url: '/DeviceType/DeviceTypes',
    method: 'get',
    params: params
  })
}
export function checkBody(params) { // 检查部位字典
  return request({
    url: '/PartGroup/PartGroups',
    method: 'get',
    params: params
  })
}
export function checkProject(params) { // 检查项目字典
  return request({
    url: '/ProcedureCode/ProcedureCodes',
    method: 'get',
    params: params
  })
}
export function imageRoom(params) { // 影像室字典
  return request({
    url: '/Device/Devices',
    method: 'get',
    params: params
  })
}
export function submit(data) { // 提交登记信息
  return request({
    url: '/Request/Register',
    method: 'post',
    data: data
  })
}
export function Patients(params) { // 病人信息列表
  return request({
    url: '/Patient/Patients',
    method: 'get',
    params: params
  })
}
export function supplement(data) { // 提交补单登记信息
  return request({
    url: '/Request/Supplement',
    method: 'post',
    data: data
  })
}
export function UpdateRegister(data) { // 修改登记信息
  return request({
    url: '/Request/UpdateRegister',
    method: 'post',
    data: data
  })
}
export function UpdateRegisterBaseInfo(data) { // 补单修改登记信息
  return request({
    url: '/Request/UpdateRegisterBaseInfo',
    method: 'post',
    data: data
  })
}
export function getList(data) { // 获取登记列表
  return request({
    url: '/Request/Requests',
    method: 'post',
    data: data
  })
}
export function AppendProcedure(data) { // 新增检查项目
  return request({
    url: '/Request/AppendProcedure',
    method: 'post',
    data: data
  })
}
export function UpdateProcedure(data) { // 修改检查项目
  return request({
    url: '/Request/UpdateProcedure',
    method: 'post',
    data: data
  })
}
export function DeleteProcedure(data) { // 删除信息
  return request({
    url: '/Request/DeleteProcedure',
    method: 'post',
    data: data
  })
}
export function RegisterPatient(datas) { // 获取患者详情
  return request({
    url: '/Request/Requisition',
    method: 'get',
    params: { regId: datas }
  })
}

export function GetHisRegisters(datas) { // 获取指定的登记单列表
  return request({
    url: '/HIS/GetHisRegisters',
    method: 'post',
    data: datas
  })
}
